interface IconsProps {
  textcolor: string;
}

export const CustomLinkedinIcon = ({
  textcolor,
}: IconsProps) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4.25"
      y="3.98047"
      width="15.75"
      height="15.75"
      rx="2"
      stroke={textcolor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.375 11.4883V16.7383"
      stroke={textcolor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.375 8.10953V8.11703"
      stroke={textcolor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 16.7305V11.4805"
      stroke={textcolor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.25 16.7305V13.5805C16.25 12.4207 15.4105 11.4805 14.375 11.4805C13.3395 11.4805 12.5 12.4207 12.5 13.5805"
      stroke={textcolor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomTwitterIcon = ({
  textcolor,
}: IconsProps) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 3.93777C21.9875 4.41919 20.9952 4.61471 19.9625 4.91044C18.8275 3.66758 17.1447 3.5988 15.5278 4.18634C13.9108 4.77388 12.8517 6.2103 12.875 7.85795V8.84046C9.58944 8.92201 6.66331 7.46987 4.775 4.91044C4.775 4.91044 0.540725 12.2134 8.825 15.718C6.9296 16.9432 5.03926 17.7694 2.75 17.683C6.09935 19.4544 9.74941 20.0636 12.9094 19.1734C16.5342 18.1516 19.513 15.5156 20.6561 11.5669C20.9971 10.366 21.1664 9.12525 21.1593 7.87957C21.1573 7.63493 22.6881 5.15607 23 3.93678V3.93777Z"
      stroke={textcolor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomFacebookIcon = ({
  textcolor,
}: IconsProps) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25 10.2305V14.2305H10.3182V21.2305H14.4091V14.2305H17.4773L18.5 10.2305H14.4091V8.23047C14.4091 7.67818 14.867 7.23047 15.4318 7.23047H18.5V3.23047H15.4318C12.6076 3.23047 10.3182 5.46904 10.3182 8.23047V10.2305H7.25"
      stroke={textcolor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomXIcon = ({
  textcolor,
}: IconsProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="-4 -4 32 33"
  >
    <path
      d="M14.095 10.316 22.286 1h-1.94L13.23 9.088 7.551 1H1l8.59 12.231L1 23h1.94l7.51-8.543 6 8.543H23zm-2.658 3.022-.872-1.218L3.64 2.432h2.98l5.59 7.821.869 1.219 7.265 10.166h-2.982z"
      stroke={textcolor}
    />
  </svg>
);

export const CustomBskyIcon = ({
  textcolor,
}: IconsProps) => (
  <svg
    width="25"
    height="22.292"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-2 -3 28 26"
  >
    <path
      d="M12.49 9.937C11.393 7.811 8.417 3.842 5.647 1.888 2.994 0.016 1.98 0.339 1.322 0.64c-0.768 0.35 -0.905 1.529 -0.905 2.221s0.377 5.69 0.631 6.52c0.823 2.756 3.736 3.688 6.424 3.387 0.137 -0.021 0.274 -0.041 0.418 -0.055 -0.137 0.021 -0.281 0.041 -0.418 0.055 -3.935 0.583 -7.438 2.016 -2.845 7.123 5.046 5.224 6.918 -1.117 7.877 -4.34 0.96 3.215 2.064 9.331 7.781 4.34 4.299 -4.34 1.179 -6.54 -2.756 -7.123 -0.137 -0.014 -0.281 -0.034 -0.418 -0.055 0.144 0.021 0.281 0.034 0.418 0.055 2.687 0.302 5.608 -0.631 6.424 -3.387 0.247 -0.836 0.631 -5.828 0.631 -6.52s-0.137 -1.872 -0.905 -2.221c-0.665 -0.302 -1.673 -0.624 -4.326 1.248 -2.79 1.961 -5.766 5.923 -6.862 8.049z"
      fill="transparent"
      stroke={textcolor}
      strokeWidth="2px"
    />
  </svg>
);

